import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=22dfaf62&"
import script from "./CheckBox.vue?vue&type=script&lang=js&"
export * from "./CheckBox.vue?vue&type=script&lang=js&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports